import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../components/layouts/mainLayout";
import SigninCard from "../../components/molecules/signinCard";
import SignupCard from "../../components/molecules/signupCard";
import { AppContext } from "../../context/AppContext";

const Auth = () => {
  const res = useContext(AppContext);
  const navigate = useNavigate();
  const user = res?.appLoadingStates?.user;
  const [currentTab, setcurrentTab] = useState(0);

  const background = "/assets/login/auth-bg.webp";


  useEffect(() => {
    if(user) navigate(`/dashboard/${user.uid}`)
  }, [])
  
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "100% 100%, cover",
          minHeight: "100vh",
          width: "100vw",
          position: "relative",
          maxWidth: "1920px",
        }}
      >
        <MainLayout>
          {currentTab === 0 ? (
            <SigninCard setcurrentTab={setcurrentTab} />
          ) : (
            <SignupCard setcurrentTab={setcurrentTab} />
          )}
        </MainLayout>
      </div>
    </div>
  );
};

export default Auth;
